<template>
  <v-menu v-bind="menuProps" offset-y>
    <template v-slot:activator="{ on, attrs }">
      <span v-on="on" v-bind="attrs" :class="activatorClass">
        <slot></slot>
      </span>
    </template>
    <v-card>
      <slot name="items" :items="items"></slot>
      <template v-for="(item, i) in items">
        <div
          v-ripple
          @click="handleItemClick(item)"
          :key="i"
          class="item-container"
        >
          <slot name="item" :item="item" class=""></slot>
        </div>
        <div v-if="i + 1 < items.length" :key="i + items.length" class="mr-2 ml-2">
          <v-divider></v-divider>
        </div>
      </template>
    </v-card>
  </v-menu>
</template>

<script>
import { dropdownMixin } from "./mixins";

export default {
  name: "Dropdown",

  mixins: [dropdownMixin],
  props: {
    items: Array,
    activatorClass: String
  },
  methods: {
    handleItemClick(item) {
      this.$emit("item-click", item);
    },
  },
};
</script>

<style scoped>
.item-container >>> div {
  padding: 0.75rem;
}
</style>